import React from 'react';
import { ButtonProps, ImageBackground, Pressable, StyleProp, Text, TextStyle, ViewStyle } from 'react-native';
import useStyles from '../../hooks/styles-hook';
import { NamedStyles } from 'react-dom';
import type { AccessibilityRole } from 'react-native';

interface CustomButtomProps extends ButtonProps {
  accessibilityRole?: AccessibilityRole;
  secondary?: boolean;
  secondaryColor?: boolean;
  secondaryColorLight?: boolean;
  secondaryColorLightOutline?: boolean;
  style?: NamedStyles<any> | NamedStyles<any>[];
  textStyle?: StyleProp<TextStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  disabledStyle?: StyleProp<ViewStyle>;
  disabledTextStyle?: StyleProp<TextStyle>;
  disabledPatternOpacity?: number;
}

const CustomButton = (props: CustomButtomProps) => {
  const styles = useStyles((section) => section.customButton);
  let buttonStyle = [styles.button.main];
  let textStyle = [styles.text.main];
  const disabledPatternOpacity =
    typeof props.disabledPatternOpacity === 'number' ? Math.min(1, Math.max(0, props.disabledPatternOpacity)) : 1;

  if (props.secondary) {
    buttonStyle.push(styles.button.secondary as any);
    textStyle.push(styles.text.secondary as any);
  }

  if (props.secondaryColor) {
    buttonStyle.push(styles.button.secondaryColor as any);
    textStyle.push(styles.text.secondaryColor as any);
  }

  if (props.secondaryColorLight) {
    buttonStyle.push(styles.button.secondaryColorLight as any);
    textStyle.push(styles.text.secondaryColor as any);
  }

  if (props.secondaryColorLightOutline) {
    buttonStyle.push(styles.button.secondaryColorLightOutline as any);
    textStyle.push(styles.text.secondaryColorLightOutline as any);
  }

  if (props.style) {
    buttonStyle.push(props.style);
  }

  if (props.textStyle) {
    textStyle.push(props.textStyle as any);
  }

  if (props.disabled) {
    buttonStyle.push(styles.button.disabled as any);
    textStyle.push(styles.text.disabled as any);

    if (props.disabledStyle) {
      buttonStyle.push(props.disabledStyle as any);
    }

    if (props.disabledTextStyle) {
      textStyle.push(props.disabledTextStyle as any);
    }
  }

  return (
    <Pressable {...props} style={buttonStyle}>
      <ImageBackground
        source={require('../../../assets/disabledBars.png')}
        style={[styles.button.backgroundImage, props.contentStyle]}
        imageStyle={{ resizeMode: 'repeat', opacity: props.disabled ? disabledPatternOpacity : 0 }}
      >
        <Text style={textStyle}>{props.title}</Text>
      </ImageBackground>
    </Pressable>
  );
};

export default CustomButton;
